export const ADD_SENSIBILISATION_EVENT = {
  socketName: "new-sensibilisation",
};

export const UPDATE_SENSIBILISATION_EVENT = {
  socketName: "update-sensibilisation",
};
